import styled from 'styled-components';

import { tokens } from '../../tokens';

interface InteriorProps {
    $extraPaddingBottom?: boolean;
}

export const FooterWrapper = styled.div`
    flex: 0 0 auto;
`;

export const Interior = styled.div<InteriorProps>`
    padding: ${tokens.spacing.tight}px;
    padding-bottom: ${({ $extraPaddingBottom }) => ($extraPaddingBottom ? `${tokens.spacing.loose}px` : undefined)};
`;
